<template>
    <v-container pa-0>
        <v-card class="px-2 pt-2 pb-6 mt-3"
                flat
                tile>
            <div class="d-flex flex-row align-center mb-2">
                <back-button :fallback-route="fallbackBackButtonRoute"/>
            </div>
            <error-list :errors="errors"></error-list>

            <v-card-title class="headline font-weight-bold pa-2">{{ $vuetify.lang.t('$vuetify.profile.avatar.title') }}</v-card-title>

            <p class="body-1 px-2">{{ $vuetify.lang.t('$vuetify.profile.avatar.description') }}</p>
            <p class="body-1 px-2 mb-0">{{ $vuetify.lang.t('$vuetify.profile.avatar.example') }}</p>
            <v-container class="px-2">
                <v-form ref="form"
                        v-model="valid"
                        lazy-validation>
                    <v-file-input accept="image/*"
                                  prepend-icon="mdi-camera"
                                  @change="changeFileInput"
                                  :rules="rules.avatar"
                                  :label="$vuetify.lang.t('$vuetify.form_items.choose_image')"
                                  class="mx-8"
                                  ref="fileInput"
                                  chips
                                  required></v-file-input>

                    <p class="text-center body-1 mb-1" v-if="image">
                        {{ $vuetify.lang.t('$vuetify.profile.avatar.preview') }}
                    </p>
                    <Cropper classname="upload-example-cropper"
                             :stencilComponent="$options.components.CircleStencil"
                             :stencil-props="stencil"
                             :src="image"
                             @change="onChangeCrop"/>

                    <!--
                    <div v-if="coordinates" class="mb-4">
                        {{ form.avatar }}
                        <code style="width: 100%;">// debug information for backend<br>{{ coordinates }}</code>
                    </div>
                    -->

                    <v-btn @click="submit"
                           :loading="whileSubmitting"
                           :disabled="whileSubmitting || !valid || !coordinates"
                           class="my-4 primary">
                        {{ $vuetify.lang.t('$vuetify.buttons.upload_and_save') }}
                    </v-btn>
                </v-form>
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
    // 3rd
    import {
        CircleStencil,
        Cropper
    } from 'vue-advanced-cropper';
    import { mapActions, } from 'vuex';
    // models
    import Profile from '../../models/Profile';
    // components
    import BackButton from '../../components/BackButton';
    import ErrorList from '../../components/ErrorList';
    // utils
    import { avatar } from '../../utils/formRules';
    import {
        LOADER_SUBMIT_AVATAR,
        ROUTE_PROFILE,
    } from '../../utils/constants';
    import {
        redirect,
        setPageTitle,
    } from '../../utils/helper';
    import { errorHandler } from '../../utils/api';

    export default {
        name: 'change-avatar',
        components: {
            Cropper,
            CircleStencil,
            BackButton,
            ErrorList,
        },
        data() {
            return {
                errors: {},
                valid: true,
                stencil: {
                    handlers: {},
                    lines: {},
                    movable: false,
                    scalable: false,
                    aspectRatio: 1,
                },
                image: null,
                coordinates: null,
                form: new FormData(),
                rules: {
                    avatar,
                },
            }
        },
        computed: {
            whileSubmitting() {
                return this.$wait.waiting(LOADER_SUBMIT_AVATAR);
            },
            fallbackBackButtonRoute() {
                return { name: ROUTE_PROFILE };
            },
        },
        methods: {
            ...mapActions([
                'setSnackbar',
            ]),
            onChangeCrop({ coordinates }) {
                if (this.image && coordinates) {
                    this.coordinates = coordinates;
                }
            },
            changeFileInput(file) {
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.image = e.target.result;
                    };
                    reader.readAsDataURL(file);
                    this.form.append('file', file);
                } else {
                    this.form = new FormData();
                    this.coordinates = null;
                    this.image = null;
                }
            },
            async submit() {
                if (!this.$refs.form.validate()) return false;
                this.form.append("coordinates[height]", this.coordinates.height);
                this.form.append("coordinates[width]", this.coordinates.width);
                this.form.append("coordinates[top]", this.coordinates.top);
                this.form.append("coordinates[left]", this.coordinates.left);

                let result = null;
                try {
                    result = await Profile.postAvatar(this.form);
                } catch (e) {
                    window.scrollTo(0, 0);
                    this.errors = errorHandler(e);
                    this.$wait.end(LOADER_SUBMIT_AVATAR);
                    return;
                }

                Profile.setAvatar(result);

                this.setSnackbar({
                    positionX: 'left',
                    type: 'success',
                    text: 'updated_avatar',
                    time: 5000,
                });

                this.$wait.end(LOADER_SUBMIT_AVATAR);
                redirect(ROUTE_PROFILE);
            },
        },
    }
</script>
